import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http'


export interface Task {
  id: number;
  name: string;
  technology?: string;
  fields?: {};
  notepadmode?: string;
  information: string;
  resulttype: string;
}

@Injectable({
  providedIn: 'root'
})

export class RunService {
  
  constructor(private http: HttpClient) { }


  getTask(task: string) {
    return this.http.get<Task>(environment.api_url + 'api/v1.0/tasks/' + task);
  }
  getFields(task: string) {
    return this.http.get<Task>(environment.api_url + 'api/v1.0/fields/' + task + '/task'); 
  }
  run(id: string, body: FormData) {
    return this.http.post(environment.api_url + 'api/v1.0/tasks/'+ id +'/checktask',  body);
  }

  updateFieldHashes(id, body) {
    return this.http.patch(environment.api_url + 'api/v1.0/fields/' + id + '/task',  body, {observe: 'response'});
  }
  updateCodeHashes(id, body) {
    return this.http.post(environment.api_url + 'api/v1.0/tasks/'+ id +'/updatehash',  body, {observe: 'response'});
  }
}
